// Module
var code = "<div class=\"row\"> <div class=\"col-md-12\"> <div class=\"panel panel-default\"> <div class=\"panel-heading\"> <h3 class=\"panel-title\">Exemple</h3> </div> <div class=\"panel-body\"> <button class=\"btn-default\" ng-click=\"$ctrl.download()\">Télécharger</button> </div> </div> </div> </div> ";
// Exports
export default code;